if (!customElements.get("m-featured-slider")) {
  class MFeaturedSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        sliderContainer: ".m-featured-slider__products",
        slideImages: ["m-featured-slider__img"],
        slideImagesContainer: ".m-featured-slider__images",
        sliderControls: ".m-slider-controls",
        prevBtn: ".swiper-button-prev",
        nextBtn: ".swiper-button-next",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const showNavigation = this.dataset.showNavigation === "true";
      const showPagination = this.dataset.showPagination === "true";
      const autoplay = this.dataset.autoplay === "true";
      const timeout = this.dataset.timeout;

      // Main product slider
this.slider = new MinimogLibs.Swiper(this.domNodes.sliderContainer, {
  speed: 400,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 24,
  centeredSlides: false,
  grabCursor: true,
  breakpoints: {
          0: {
            slidesPerView: '1',
          },
          768: {
            slidesPerView: 'auto',
          },
        },
  autoplay: autoplay
    ? {
        delay: parseInt(timeout),
        disableOnInteraction: false,
      }
    : false,
  pagination: showPagination
    ? {
        el: this.querySelector(".swiper-pagination"),
        type: "bullets",
        clickable: true,
      }
    : false,
  on: {
    init: (swiper) => {
      if (showNavigation) {
        if (this.domNodes.prevBtn) {
          this.domNodes.prevBtn.addEventListener("click", () => swiper.slidePrev());
        }
        if (this.domNodes.nextBtn) {
          this.domNodes.nextBtn.addEventListener("click", () => swiper.slideNext());
        }
      }

      // Initial arrow state
      this.toggleArrowState(swiper);
    },
    slideChange: (swiper) => {
      this.toggleArrowState(swiper);
    },
  },
});


      // Sync image slider
      this.imageSlider = new MinimogLibs.Swiper(this.domNodes.slideImagesContainer, {
        speed: 500,
        loop: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });

      this.slider.on("activeIndexChange", (swiper) => {
        this.imageSlider.slideTo(swiper.activeIndex);
      });

      this.imageSlider.on("activeIndexChange", (swiper) => {
        this.slider.slideTo(swiper.activeIndex);
      });

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    toggleArrowState(swiper) {
  const maxTranslate = swiper.maxTranslate();
  const currentTranslate = swiper.translate;

  const isAtBeginning = swiper.isBeginning;
  const isAtEnd = currentTranslate <= maxTranslate + 1; // allow tiny buffer

  if (this.domNodes.prevBtn) {
    this.domNodes.prevBtn.classList.toggle("is-disabled", isAtBeginning);
  }

  if (this.domNodes.nextBtn) {
    this.domNodes.nextBtn.classList.toggle("is-disabled", isAtEnd);
  }
}


    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      if (this.slider) this.slider.slideToLoop(index);
      if (this.imageSlider) this.imageSlider.slideToLoop(index);
    }
  }

  customElements.define("m-featured-slider", MFeaturedSlider);
}
